import { Hero } from "../components/sections/Hero";
import { StatsBand } from "../components/sections/StatsBand";
import { AboutManifesto } from "../components/sections/AboutManifesto";
import { CoreServicesGrid } from "../components/sections/CoreServicesGrid";
import { Marquee } from "../components/common/Marquee";
import { ManpowerSolutions } from "../components/sections/ManpowerSolutions";
import { IndustriesGrid } from "../components/sections/IndustriesGrid";
import { BpoSection } from "../components/sections/BpoSection";
import { ConstructionSection } from "../components/sections/ConstructionSection";
import { WhyFrontxGrid } from "../components/sections/WhyFrontxGrid";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { FinalCTA } from "../components/sections/FinalCTA";

export default function Home() {
    return (
        <>
            <Hero />
            <StatsBand />
            <AboutManifesto />
            <CoreServicesGrid />
            <Marquee items={["Enterprise Ready Workforce", "PAN India Operations", "Scalable Manpower", "Project Execution"]} />
            <ManpowerSolutions />
            <IndustriesGrid limit={8} />
            <BpoSection />
            <ConstructionSection />
            <WhyFrontxGrid />
            <ProcessTimeline />
            <FinalCTA />
        </>
    );
}
